import { redirect } from 'react-router';

import { authLoginRoute } from './auth.routes';

type Args = {
  request: Request;
};

export function redirectRequireAuthentication({ request }: Args) {
  const url = new URL(request.url);

  return redirect(
    authLoginRoute.with({
      to: `${url.pathname}${url.search}`,
      auth_required: 1,
    }),
  );
}
